// extracted by mini-css-extract-plugin
export var blink = "_6d-2";
export var cursor = "_6d-1";
export var reactMarkdown = "_6d-3";
export var streamingText = "_6d-0";